export enum PolygonEventType {
  DrawingStarted = 'drawingStarted',
  DrawingEnd = 'drawingEnd',
  DashedLineDeleted = 'dashedLineDeleted',
  PolygonCreated = 'polygonCreated',
  VertexModifiedInPolygon = 'vertexModifiedInPolygon',
  EditingLockChanged = 'editingLockChanged',
}
